<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="licenseList"
	[loading]="!licenseList"
	[globalFilterFields]="app.keys(licenseList)"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="700px"
	[virtualScroll]="true"
	[virtualRowHeight]="40"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="name">
				<div class="d-flex w-100">
					Name
					<p-sortIcon field="name"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="source" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="checkNumber">
				<div class="d-flex w-100">
					MAC Address
					<p-sortIcon field="mac"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="mac" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="checkNumber">
				<div class="d-flex w-100">
					Version
					<p-sortIcon field="softwareVersion"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="softwareVersion" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="checkNumber">
				<div class="d-flex w-100">
					Type
					<p-sortIcon field="deviceType"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="deviceType" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="onDeviceSelected = rec; onDeviceSelectedChange.emit(rec)">
			<td>
				<span *ngIf="rec.claimed">
					{{ rec.name }}
				</span>
				<span *ngIf="!rec.claimed">
					<i>license available</i>
				</span>
			</td>
			<td>
				{{ rec.mac }}
			</td>
			<td>
				{{ rec.softwareVersion }}
			</td>
			<td>
				{{ rec.deviceType }}
			</td>
		</tr>
	</ng-template>
</p-table>
